import { apiClient } from './client'
import type { Source } from '../types'

export const sourcesApi = {
  getSources: async (): Promise<Source[]> => {
    const response = await apiClient.get('/sources')
    return response.data
  },

  getSource: async (id: number): Promise<Source> => {
    const response = await apiClient.get(`/sources/${id}`)
    return response.data
  },

  createSource: async (source: Partial<Source>): Promise<Source> => {
    const response = await apiClient.post('/sources', source)
    return response.data
  },
}
